var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKslWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "841.89px",
    height: "595.28px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#146E28;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.89,161.64c-50.76,49.92-101.09,99.43-151.95,149.44c52.83,57.08,105.65,114.14,159.68,172.52 c-4.02,0-6.28,0-8.54,0c-23.78,0.02-47.56,0.12-71.34-0.05c-2.51-0.02-5.77-0.86-7.4-2.56c-29.9-30.91-59.63-61.99-89.35-93.08 c-17.42-18.22-34.75-36.52-53.1-55.82c0,51.04,0,100.62,0,150.75c-20.93,0-41.32,0-62.09,0c0-106.67,0-213.18,0-320.28 c20.36,0,40.74,0,61.62,0c0,46.06,0,92.23,0,139.6c2.08-1.68,3.37-2.56,4.46-3.64c45.22-44.33,90.38-88.73,135.74-132.91 c2.29-2.23,6.27-3.77,9.49-3.81C259.05,161.49,283,161.64,307.89,161.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387,159.4c-24.12,5.52-45.45,16.01-60.81,36.25c-13.8,18.18-18.19,39.02-17.42,61.48 c1.17,34.34,15.94,60.58,47.59,74.4c19.71,8.61,41.03,13.65,61.79,19.74c17.68,5.19,35.9,8.68,53.32,14.56 c22.18,7.48,24.63,31.99,16.45,46.38c-5.2,9.14-13.67,14.25-23.46,16.97c-27.91,7.74-55.02,4.26-81.26-7.05 c-15.6-6.72-28.63-17.29-40.38-29.65c-13.69,12.86-27.02,25.37-40.64,38.17c16.3,19.05,33.89,35.36,57.01,44.57 c17.3,6.89,35.3,10.7,53.79,12.63c28.7,2.99,56.86,1.15,83.83-9.72c23.03-9.29,42.25-23.46,52.8-46.82 c7.82-17.31,9.29-35.71,6.98-54.42c-3.41-27.67-15.96-49.63-41.91-61.59c-13.96-6.44-28.71-11.48-43.52-15.7 c-23.49-6.71-47.38-12.01-70.99-18.3c-10.06-2.68-18.65-8.12-23.66-17.66c-10.22-19.45-0.01-41.9,22.38-48.31 c18.29-5.24,36.62-3.84,54.68,1.96c5.99,1.92,11.49,4.57,16.65,7.69c3.57-25.73,15.54-42.68,23.15-51.13 C460.83,156.06,425.51,150.59,387,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M674.91,182.17l-63.2,91.68c0,84.75,0,143.09,0,208.74c69.37,0,137.82,0,206.39,0c0-19.06,0-37.48,0-56.24 c-2.88,0-5.25,0-7.61,0c-42.81,0.05-85.62,0-128.43,0.26c-5.48,0.03-7.38-1.06-7.36-7.05L674.91,182.17z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M769,50.01c0.9-2.86,0.49-5.66-2.33-8.39c-4.18-4.05-7.37-0.14-10.08,2.08 c-13.84,11.36-27.64,22.79-41.08,34.62c-39.09,34.38-78.02,68.94-116.99,103.46c-14.02,12.42-27.96,24.92-41.56,37.04 c-13.93-10.3-27.51-20.19-40.93-30.3c-7.4-5.57-14.95-10.46-22.65-14.67c-7.62,8.46-19.59,25.4-23.15,51.13 c11.53,6.96,21.4,16.32,31.42,25.44c20.77,18.9,41.2,38.18,62.11,56.91c10.92,9.78,19.18,9.1,28.94-1.93L769,50.01z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKslWhiteLogo);
export default __webpack_public_path__ + "static/media/KslWhiteLogo.3e0e84680d99a784ac1bc4c463e8291d.svg";
export { ForwardRef as ReactComponent };